import React from "react";
import Datatables from "./Datatables";
import Parser from "html-react-parser";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function DirectIncome(props) {
  const columns = [
    {
      name: "Contact",
      selector: (row) => Parser(row.contactRef),
      sortable: true,
    },
    {
      name: "Reference",
      selector: (row) => row.reference,
      sortable: true,
    },
    {
      name: "Account",
      selector: (row) => (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="button-tooltip-2">{row.paymentAllocations}</Tooltip>
          }
        >
          {({ ref, ...triggerHandler }) => (
            <div
              ref={ref}
              {...triggerHandler}
              className="ml-2 cursor-pointer ellipsis-text"
            >
              {row.paymentAllocations}{" "}
            </div>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
    },
    {
      name: "Payment Date",
      selector: (row) => row.issueDate,
      sortable: true,
    },
    {
      name: "currency",
      selector: (row) => row.currency,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => Parser(row.totalAmount),
      sortable: true,
    },
  ];

  const finalUrl = `${props.endUrl}/CODAT/DirectIncome/${props.leadId}`;

  return (
    <Datatables title={props.title} apiUrl={finalUrl} apiColumn={columns} />
  );
}
